'use client';
import React, { useState } from 'react';

interface TestimonialItem {
  quote: string;
  name: string;
  title: string;
  image: { src: string; alt: string };
}

interface TestimonialCarouselProps {
  items: TestimonialItem[];
}

export default function TestimonialCarousel({ items }: TestimonialCarouselProps) {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c - 1 + items.length) % items.length);
  const next = () => setCurrent((c) => (c + 1) % items.length);

  const item = items[current];

  return (
    <div className="w-full">
      <div className="relative rounded-2xl p-8 md:p-12" style={{ backgroundColor: '#f3f4f6', border: '1px solid #08294a' }}>
        <p className="mb-6 text-2xl" style={{ color: '#08294a', fontFamily: 'Source Sans 3, sans-serif' }}>
          &ldquo;{item.quote}&rdquo;
        </p>
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#08294a', color: '#ffffff', fontFamily: 'Source Sans 3, sans-serif', fontSize: '16px', fontWeight: 600 }}>
            {item.name.charAt(0)}
          </div>
          <div>
            <p className="font-semibold text-sm" style={{ color: '#08294a', fontFamily: 'Source Sans 3, sans-serif' }}>{item.name}</p>
            <p className="text-xs" style={{ color: '#4a6a80', fontFamily: 'Source Sans 3, sans-serif' }}>{item.title}</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center gap-4 mt-6">
        <button onClick={prev} className="p-2 rounded-full transition-colors" style={{ color: '#08294a', border: '1px solid #08294a' }}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="20" height="20">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button>
        <div className="flex gap-2">
          {items.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className="w-2 h-2 rounded-full transition-colors"
              style={{ backgroundColor: i === current ? '#08294a' : '#c0cdd6' }}
            />
          ))}
        </div>
        <button onClick={next} className="p-2 rounded-full transition-colors" style={{ color: '#08294a', border: '1px solid #08294a' }}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="20" height="20">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </button>
      </div>
    </div>
  );
}
